"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _photographyClientLib = require("@wix/photography-client-lib");
var FullscreenCartButton = /*#__PURE__*/function (_React$Component) {
  function FullscreenCartButton() {
    return _React$Component.apply(this, arguments) || this;
  }
  (0, _inheritsLoose2["default"])(FullscreenCartButton, _React$Component);
  var _proto = FullscreenCartButton.prototype;
  _proto.getDefualtButtonText = function getDefualtButtonText() {
    return _photographyClientLib.translationUtils ? _photographyClientLib.translationUtils.getByKey('Gallery_ArtStore_UOU_Add_To_Cart_Button') : '';
  };
  _proto.render = function render() {
    var _this$props = this.props,
      cartItemsCount = _this$props.cartItemsCount,
      styleParams = _this$props.styleParams,
      mobileShopFrameOpen = _this$props.mobileShopFrameOpen,
      onAddToCartRequest = _this$props.onAddToCartRequest;
    var className = ['artstore-add-to-cart-button'];
    mobileShopFrameOpen && className.push('mobile-shop-frame-open');
    cartItemsCount ? className.push('pro-fullscreen-checkout-link-appears') : className.push('has-custom-focus');
    var buttonText = styleParams.addToCartButtonText || this.getDefualtButtonText();
    return /*#__PURE__*/_react["default"].createElement("button", {
      className: className.join(' '),
      tabIndex: 0,
      "aria-label": buttonText,
      onClick: onAddToCartRequest
    }, /*#__PURE__*/_react["default"].createElement("div", null, buttonText), /*#__PURE__*/_react["default"].createElement("div", {
      className: "pro-fullscreen-overlay"
    }));
  };
  return FullscreenCartButton;
}(_react["default"].Component);
var _default = exports["default"] = FullscreenCartButton;